import * as React from 'react';
import { observer } from 'mobx-react';
import * as classNames from 'classnames';

// Styles
const s = require('./Button.css');

// Enumerables
export enum EButtonType {
    Default,
    BorderOnly,
    Action,
    Important,
    ImportantBorderOnly,
    Success
}

// Props
interface IButtonProps {
    onClick?: ((e: React.MouseEvent<HTMLButtonElement>) => void) | null;
    className?: string | null;
    inBox?: boolean;
    tabIndex?: number;
    type?: EButtonType;
    icon?: {
        element: JSX.Element | null;
        className?: string;
        onLeft?: boolean;
    } | null;
}

// Component
@observer
export class Button extends React.Component<IButtonProps, {}> {
    static get defaultProps(): IButtonProps {
        return {
            onClick: null,
            className: null,
            inBox: false,
            tabIndex: null,
            type: EButtonType.Default,
            icon: {
                element: null,
                className: null,
                onLeft: false
            }
        };
    }

    public container: HTMLButtonElement = null;
    private referenceContainer = (ref) => this.container = ref;

    public render() {
        // Destructure
        const { className, type, inBox, icon } = this.props;

        // Render
        return (
            <button
                ref={this.referenceContainer}
                tabIndex={this.props.tabIndex !== null ? this.props.tabIndex : undefined}
                onClick={this.handleButtonClick}
                className={classNames(s.button, className, {
                    [s.box]: inBox,
                    [s.borderOnly]: type === EButtonType.BorderOnly,
                    [s.action]: type === EButtonType.Action,
                    [s.important]: type === EButtonType.Important,
                    [s.importantBorderOnly]: type === EButtonType.ImportantBorderOnly,
                    [s.success]: type === EButtonType.Success
                })}
            >
                {(
                    (typeof icon.element !== 'undefined' && icon.element) &&
                    (typeof icon.onLeft !== 'undefined' && icon.onLeft === true)
                ) && (
                    <span className={classNames(s.icon, icon.className)}>
                        {icon.element}
                    </span>
                )}

                <span className={s.children}>
                    {this.props.children}
                </span>

                {(
                    (typeof icon.element !== 'undefined' && icon.element) && (
                        (typeof icon.onLeft === 'undefined') ||
                        (typeof icon.onLeft !== 'undefined' && icon.onLeft === false)
                    )
                ) && (
                    <span className={classNames(s.icon, icon.className)}>
                        {icon.element}
                    </span>
                )}
            </button>
        );
    }

    private handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (this.props.onClick) {
            this.props.onClick(e);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/action/Button.tsx